<template>
  <!-- @submit.prevent="handlesubmit" -->
  <div class="form">
    <form>
      <input
        v-model="username"
        placeholder="Username"
        type="text"
        class="underline pb-1"
        v-on:input="onChangeText(username, 1)"
        required
      />
      <p
        v-if="warningUsername"
        :class="isMatchPasswordStyle"
        class="textalet"
        style="margin-bottom: 0px; color: red"
        required
      >
        {{ isTrueUsername }}
      </p>

      <input
        v-model="email"
        placeholder="E-mail"
        type="email"
        class="underline pb-1 mt-4"
        v-on:input="onChangeText(email, 2)"
        required
      />
      <!-- {{registerSuccessStatus}} -->
      <!-- {{this.$store.getters('registerSuccessStatus')}} -->
      <input
        v-model="password"
        placeholder="Password"
        type="password"
        class="underline pb-1 mt-4"
        v-on:input="onChangeText(password, 3)"
        @input="new_password"
        required
      />

      <CRow
        class="lnu_container nonePaddingHorizontal"
        style="width: 22rem; margin-left: 0px;"
      >
        <CCol class="strong">
          <p v-if="conditionLowerCase" class="tooltip-condition">
            Please complete this condition
            <a class="tooltip-condition-arrow"></a>
          </p>
          <p v-bind:class="{ lovercase_valid: new_contains_lovercase }">
            Lowercase
          </p>
        </CCol>
        <CCol class="strong">
          <p v-if="conditionUpperCase" class="tooltip-condition">
            Please complete this condition
            <a class="tooltip-condition-arrow"></a>
          </p>
          <p v-bind:class="{ uppercase_valid: new_contains_uppercase }">
            Uppercase
          </p>
        </CCol>
        <CCol class="strong">
          <p v-if="conditionNumber" class="tooltip-condition">
            Please complete this condition
            <a class="tooltip-condition-arrow"></a>
          </p>
          <p v-bind:class="{ number_valid: new_contains_number }">Number</p>
        </CCol>
        <CCol class="strong">
          <p v-if="conditionPwdCount" class="tooltip-condition">
            Please complete this condition
            <a class="tooltip-condition-arrow"></a>
          </p>
          <p v-bind:class="{ uppercase_valid: new_valid_password_length }">
            More than 7
          </p>
        </CCol>
      </CRow>
      <!--  -->

      <input
        v-model="confirmpassword"
        placeholder="Confirm password"
        type="password"
        class="underline pb-1 mt-4"
        v-on:input="onChangeText(confirmpassword, 4)"
        required
      />

      <!-- <h1
        style="color:black"
      >{{setPasswordSecurity(new_contains_lovercase,new_contains_uppercase,new_contains_number,new_valid_password_length)}}</h1>-->
      <p v-if="warningPassword" :class="isMatchPasswordStyle" class="textalet">
        {{ isMatchPassword }}
      </p>

      <p v-if="loading" class="mt-4 text-center" style="color: #000">
        <i class="fas fa-circle-notch fa-spin"></i>...Please wait
      </p>

      <Button v-else :click="onSignUp" style="margin-top: 1.5rem"
        >SIGN UP</Button
      >
    </form>

    <!-------------- Modal Verify OTP ------------------>
    <ModalVerifyOTP :show="this.$store.getters.dialogOTPHolderGetter" />
    <!-- <CModal
      :show.sync="this.$store.getters.dialogOTPHolderGetter"
      :centered="true"
      add-content-classes="bgmodalmdl"
      :closeOnBackdrop="false"
    >
      <template #body-wrapper>
        <div class="modal-text">
          <div class="p-3 mt-3">
            <h1 class="ml-4 mt-3">SIGN UP</h1>
            <input
              v-model="token"
              v-on:input="onChangeText(token, 5)"
              placeholder="Fill your verify code from your registered e-mail"
              type="Verify"
              class="underlineforgot ml-4 mt-3"
              style="
                padding-bottom: 0px;
                padding-top: 0px;
                padding-left: 0px;
                padding-right: 0px;
              "
            />
            <CButton @click="confirmOTP" class="btnforgot mt-3">Summit</CButton>
          </div>
        </div>
      </template>
      <template #header-wrapper>
        <div></div>
      </template>
      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal> -->

    <!--------------------- Modal Verify OTP Success ----------------------->
    <CModal
      title="Modal title"
      :show.sync="registerSuccessStatus"
      :centered="true"
      add-content-classes="bgmodalmdl"
      :closeOnBackdrop="false"
    >
      <template #body-wrapper>
        <div class="modal-text-success">
          <div class="p-3 mt-1 text-center">
            <h1 class="mt-4">REGISTER SUCCESSFULLY</h1>
            <p>
              <small>Please Sign in with New Account</small>
            </p>
            <p class="modal-text mt-4 mb-0 mr-4"></p>
            <CButton @click="closeAllModal()" class="btnforgot mt-4 mb-3"
              >OK</CButton
            >
          </div>
        </div>
      </template>
      <template #header-wrapper>
        <div></div>
      </template>
      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>

    <CModal
      title="Modal title"
      :show.sync="warningModal"
      add-content-classes="bgmodalmdl"
      :closeOnBackdrop="false"
    >
      <template #body-wrapper>
        <div class="modal-text-success">
          <div class="p-3 mt-1">
            <h1 class="mt-4">Permission Denied.</h1>

            <p class="modal-text mt-4 mb-0 mr-4">
              The registration function is not available now.<br />
              <small
                ><br />
                For Chinese 1 student,<br
              /></small>
              <small
                >please login MDL System with your
                <a style="font-weight: bold">Reg Username, Password</a></small
              >.
            </p>
            <p class="modal-text mt-4 mb-0 mr-4">
              <small
                >Contact us
                <a href="https://lin.ee/vENXiDs">MDL Line official</a>
              </small>
            </p>
            <CButton @click="closeAllModal()" class="btnforgot mt-4 mb-3"
              >OK</CButton
            >
          </div>
        </div>
      </template>
      <template #header-wrapper>
        <div></div>
      </template>
      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<script>
import Button from "../signInCss/Button";
// import Service from "../service/api";
import store from "@/store/store";
import moment from "moment";
import Countdown from "vuejs-countdown";
import Facebook from "../../components/authentication/Facebook";
import { mapGetters } from "vuex";
import ModalVerifyOTP from "./ModalVerifyOTP";
// import func from "../../../vue-temp/vue-editor-bridge";

export default {
  name: "Signup",
  props: {
    signup: Function,
    changeModalStatus: Function,
  },
  data() {
    return {
      dialog: {
        message: "",
        type: "danger",
        status: false,
      },
      // clientId:
      //   "553738419453-k89tphdnkkvb0crthf9havd83iq3k7k2.apps.googleusercontent.com",
      username: "",
      email: "",
      password: null,
      confirmpassword: null,
      varify: "",
      icon: "google",
      modalVerify: false,
      successfullyRegister: false,
      isSignIn: false,
      secret: this.$store.getters.OTPSecretGetter,
      token: "",
      warningPassword: false,
      isMatchPassword: "Password doesn't match",
      isMatchPasswordStyle: "",
      new_contains_lovercase: false,
      new_contains_number: false,
      new_contains_uppercase: false,
      new_valid_password_length: false,
      new_valid_password: false,

      warningUsername: false,
      // isTrueUsername: "Username can not use",
      isTrueUsername: "",
      loading: false,

      conditionLowerCase: false,
      conditionUpperCase: false,
      conditionNumber: false,
      conditionPwdCount: false,
      warningModal: false,
    };
  },
  components: {
    Button,
    Facebook,
    Countdown,
    ModalVerifyOTP,
  },
  created() {
    this.$store.commit("closeRegisterSuccessModal");
    this.$store.commit("closeDialog");
  },
  mounted() {},
  computed: {
    ...mapGetters({
      dialogOTPHolderGetter: "dialogOTPHolderGetter",
      registerSuccessStatus: "registerSuccessStatus",
      getLoadingSignup: "getLoadingSignup",
    }),
  },
  beforeDestroy() {},
  watch: {
    getLoadingSignup: function(value) {
      this.loading = value;
    },
    dialogOTPHolderGetter: function(value) {
      this.modalVerify = value;
    },
    registerSuccessStatus: function(value) {
      this.$store.commit("closeDialog");
      this.successfullyRegister = value;
    },
  },
  methods: {
    // ----------------------------------------------------------------------------------------------------
    onHideNotice: function() {
      if (this.conditionLowerCase == true) {
        this.conditionLowerCase = false;
      }
      if (this.conditionUpperCase == true) {
        this.conditionUpperCase = false;
      }
      if (this.conditionNumber == true) {
        this.conditionNumber = false;
      }
      if (this.conditionPwdCount == true) {
        this.conditionPwdCount = false;
      }
    },
    new_password: function() {
      this.new_password_length = this.password.length;
      if (this.new_password_length > 7) {
        this.new_valid_password_length = true;
      } else {
        this.new_valid_password_length = false;
      }

      this.new_contains_lovercase = /[a-z]/.test(this.password);
      this.new_contains_number = /\d/.test(this.password);
      this.new_contains_uppercase = /[A-Z]/.test(this.password);

      // Check if the password is valid
      if (
        this.new_contains_lovercase == true &&
        this.new_contains_number == true
      ) {
        this.new_valid_password = false;
        if (
          this.new_contains_uppercase == true &&
          this.new_valid_password_length == true
        )
          this.new_valid_password = true;
      } else {
        this.new_valid_password = false;
      }
    },
    closeAllModal() {
      this.closeSuccessfullyModal();
      //this.changeModalStatus();
      this.$emit("onRegistered");
    },
    closeSuccessfullyModal: function() {
      this.$store.commit("closeRegisterSuccessModal");
      this.clearData();
    },
    confirm_password: function() {
      this.confirm_password_length = this.confirmPassword.length;
      if (this.confirm_password_length > 7) {
        this.confirm_valid_password_length = true;
      } else {
        this.confirm_valid_password_length = false;
      }

      this.confirm_contains_lovercase = /[a-z]/.test(this.confirmPassword);
      this.confirm_contains_number = /\d/.test(this.confirmPassword);
      this.confirm_contains_uppercase = /[A-Z]/.test(this.confirmPassword);

      // Check if the password is valid
      if (
        this.confirm_contains_lovercase == true &&
        this.confirm_contains_number == true
      ) {
        this.confirm_valid_password = false;
        if (
          this.confirm_contains_uppercase == true &&
          this.confirm_valid_password_length == true
        )
          this.confirm_valid_password = true;
      } else {
        this.confirm_valid_password = false;
      }
    },
    showNewPassword() {
      this.newPasswordType =
        this.newPasswordType === "password" ? "text" : "password";
    },
    showConfirmPassword() {
      this.confirmPasswordType =
        this.confirmPasswordType === "password" ? "text" : "password";
    },
    confirmOTP() {
      let secretHolder = this.$store.getters.OTPSecretGetter;
      let payload = {
        token: this.token,
        secret: secretHolder,
      };
      this.$store.dispatch("confirmOTPaction", payload);
    },
    closedia() {
      this.$store.commit("closeDialog");
    },
    clearData() {
      this.username = "";
      this.email = "";
      this.password = "";
      this.confirmpassword = "";
    },
    onSignUp() {
      let enable = false;
      if (enable == false) {
        this.warningModal = true;
      } else {
        let err = false;
        let signupData = {
          username: this.username,
          email: this.email,
          password: this.password,
        };
        if (this.password == null) {
          alert("Please fill information before click signup button");
        } else if (this.warningUsername == true) {
          alert("Can not use this Username");
        }
        if (this.new_contains_lovercase == false) {
          err = true;
          this.conditionLowerCase = true;
        }
        if (this.new_contains_uppercase == false) {
          err = true;
          this.conditionUpperCase = true;
        }
        if (this.new_contains_number == false) {
          err = true;
          this.conditionNumber = true;
        }
        if (this.new_valid_password_length == false) {
          err = true;
          this.conditionPwdCount = true;
        }
        if (err) {
          setTimeout(() => {
            this.onHideNotice();
          }, 2000);
        } else if (
          this.username &&
          this.email &&
          this.password &&
          this.confirmpassword !== null &&
          this.password == this.confirmpassword
        ) {
          this.warningPassword = false;
          this.warningUsername = false;

          this.$store.dispatch("onSignUp", signupData);
        } else {
          alert("Please fill information before click signup button");
        }
      }
      // if (this.password == this.confirmpassword) {
      //   this.warningPassword = false;
      //   alert("เข้าระบบแล้ว");
      //   // this.$store.dispatch("onSignUp", signupData);
      //   // this.clearData();
      // } else {
      //   alert("Please re-enter your password");
      // }
    },

    onChangeText(textHolder, id) {
      this.isTrueUsername = "";
      this.isMatchPasswordStyle = "";
      if (id == 1) {
        let regExp = /[^A-Za-z0-9]/;
        if (!regExp.test(textHolder) && textHolder.length >= 8) {
          let verified = parseInt(textHolder);
          if (Number.isInteger(verified) && verified.toString().length >= 8) {
            this.warningUsername = true;
            this.isTrueUsername = "Please fill at least one letter";
            this.isMatchPasswordStyle = "error-password";
          } else {
          }
        } else if (!regExp.test(textHolder) && textHolder.length !== 8) {
          this.warningUsername = false;
        } else {
          this.warningUsername = true;
          this.isMatchPasswordStyle = "error-password";
          this.isTrueUsername = "Can not use special characters";
        }
      } else if (id == 2) {
        this.email = textHolder;
      } else if (id == 3) {
        this.password = textHolder;
        if (this.confirmpassword != this.password) {
          this.isMatchPasswordStyle = "error-password";
          this.warningPassword = true;
          this.isMatchPassword = "Password doesn't match";
        }
      } else if (id == 4) {
        this.confirmpassword = textHolder;
        if (this.confirmpassword != this.password) {
          this.isMatchPasswordStyle = "error-password";
          this.warningPassword = true;
          this.isMatchPassword = "Password doesn't match";
        }
        if (this.confirmpassword == this.password) {
          this.isMatchPasswordStyle = "match-password";
          this.isMatchPassword = "Password matches";
          this.warningPassword = true;
        }
      } else if (id == 5) {
        this.token = textHolder;
      }
    },

    signInGoogleHandler() {
      this.$gAuth
        .signIn()
        .then((user) => {
          // On success do something, refer to https://developers.google.com/api-client-library/javascript/reference/referencedocs#googleusergetid
          this.isSignIn = this.$gAuth.isAuthorized;

          this.$store.dispatch("loginGoogle", {
            accessToken: user.wc.access_token,
          });
        })
        .catch((error) => {});
    },
    signOutGoogleHandler() {
      this.$gAuth
        .signOut()
        .then(() => {
          this.isSignIn = this.$gAuth.isAuthorized;
          alert("Successfully sign out from google");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
.bgmodalmdl {
  border-radius: 30px;
  width: 100%;
}
.tooltip-condition {
  position: absolute;
  z-index: 9;
  color: #fff !important;
  background: #dc3545 !important;
  padding: 5px;
  top: -80px;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
}
.tooltip-condition-arrow {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid #dc3545;

  position: absolute;
  bottom: -10px;
  left: 50%;
  margin-left: -15px;
}
.error-password {
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  color: #ff4a4a;
  font-style: italic;
  margin-top: 0.5em;
}
.match-password {
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  color: #00cc00;
  font-style: italic;
  margin-top: 0.5em;
}
</style>

<style scoped>
.button-google {
  color: #ea4335;
  background-color: black;
}
.button {
  outline: none;
  border: none;
  width: 100%;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 40px;
  font-size: 16px;
  background-color: black;
}
.form {
  padding: 30px 36px 40px 36px;
}
.invalid {
  color: red;
  float: left;
  font-size: 18px;
  margin-top: 8px;
}

.forgot {
  color: black;
  float: right;
  font-size: 18px;
  margin-top: 8px;
}

#info-block section {
  border-top: 1px solid black;
  text-align: center;
}

.file-marker > div {
  padding: 0 3px;
  margin-top: -0.9em;
}
.box-title {
  background: #b8b8b8 none repeat scroll 0 0;
  display: inline-block;
  color: black;
  padding: 0 2px;
}

input {
  font-size: 20px;
  width: 100%;
  margin-top: 12px;
  padding-bottom: 9px;
}

.underline {
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid #cccccc;
  font-size: 14px;
  width: 100%;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: grey;
  opacity: 1; /* Firefox */
  font-weight: 100%;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
}

.modal-content {
  background-color: #b9b9b9 !important;
}

/* ::-webkit-input-placeholder {
  color: gray;
} */
fieldset {
  display: block;
  margin: 20px 1%;
  margin-bottom: 20px;
  padding: 0 auto;
  padding: 15px 0;
  border: 0;
  border-top: 1px solid #cccccc;
  width: 98%;
}

fieldset:last-of-type {
  margin-bottom: 0px;
}

legend {
  display: table;
  min-width: 0px;
  max-width: 8%;
  margin: auto;
  color: black;
  font-size: 12px;
  text-align: center;
}

/* css modal-verify */
.modal-text h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: black;
  text-align: left;
}
.modal-text p {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-size: 16px;
  color: black;
  text-align: left;
}
.underlineforgot {
  border: 0;
  outline: 0;
  background: transparent;
  width: 90%;
  border-bottom: 0.5px solid #cccccc;
}
.btnforgot {
  display: block;
  background-color: #0080ff;
  width: 173px;
  border-radius: 30px;
  padding-left: auto;
  color: white;
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  text-align: center;
  margin: 0 auto;
}
/* end css modal-verify */
.lovercase_valid,
.number_valid,
.uppercase_valid {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

.lnu_container {
  margin-top: 0.5rem;
  width: 100%;
  height: auto;
  display: flex;
}

.lnu_container p {
  width: 100%;
  font-size: 10.7px;
  line-height: 2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 99, 0.8);
  background: linear-gradient(to right, #0080ff 50%, #eee 50%);
  background-size: 201% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.lovercase_valid,
.number_valid,
.uppercase_valid {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}
/* -------------------------------------------- NEW CSS -------------------------------------------- */
.lnu_container {
  margin-top: 0.5rem;
  width: 108%;
  height: auto;
  display: flex;
  /* justify-content: space-between; */
}

.modal-text-success h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 22px;
  color: black;
  text-align: center;
}
.modal-text-success p {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-size: 16px;
  color: black;
  margin-left: 8%;
}

.lnu_container p {
  width: 100%;
  font-size: 10.7px;
  line-height: 2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 99, 0.8);
  background: linear-gradient(to right, #0080ff 50%, #eee 50%);
  background-size: 201% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.strong {
  padding-left: 0;
  padding-right: 3px;
  margin-bottom: -30px;
}
.textalet {
  /* color: red; */
  font-size: 12px;
  margin-top: 0.7em;
  font-style: italic;
}

@media screen and (max-width: 415px) {
  .lnu_container {
    max-width: 108%;
  }
}
</style>
